import { render, staticRenderFns } from "./Lgx196025685548990464.vue?vue&type=template&id=d3fb8ce4&"
import script from "./Lgx196025685548990464.vue?vue&type=script&lang=js&"
export * from "./Lgx196025685548990464.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports